export default __webpack_public_path__ + "static/media/Rectangle 365.41831f92.png";